import React, { Component } from "react"
import Modal from "react-modal"
import ProductItemModalUI from "./ProductItemModalUI"
import RestApiUtils from "../../../apiclient/moebli/RestApiUtils"

class ProductItemModalSF extends Component {
	constructor(props) {
		super(props)
		this.state = {
			successMsg: null,
			errorList: null,

			submitted: false,

			productItemId: '',
			productItemIdError: null,
			priceF: '',
			priceFError: null,
			//
			maker: '',
			makerError: null,
			itemName: '',
			itemNameError: null,
			description: '',
			descriptionError: null,
		}
	}

	render() {
		return (
			<ProductItemModalUI
				context={this.props.context}
				errorList={this.state.errorList}
				successMsg={this.state.successMsg}
				setErrorList={this.setErrorList}

				createMode={this.props.createMode}
				submitted={this.state.submitted}

				onSubmit={this.onSubmit}
				onCancelCreate={this.onCancelCreate}

				productItemId={this.state.productItemId}
				onProductItemIdChange={(event) => { this.setState({ productItemId: event.target.value }) }}
				productItemIdError={this.state.productItemIdError}
				setProductItemIdError={(error) => { this.setState({ productItemIdError: error }) }}

				priceF={this.state.priceF}
				onPriceFChange={(event) => { this.setState({ priceF: event.target.value }) }}
				priceFError={this.state.priceFError}
				setPriceFError={(error) => { this.setState({ priceFError: error }) }}
				//
				maker={this.state.maker}
				onMakerChange={(event) => { this.setState({ maker: event.target.value }) }}
				makerError={this.state.makerError}
				setMakerError={(error) => { this.setState({ makerError: error }) }}
				//
				itemName={this.state.itemName}
				onItemNameChange={(event) => { this.setState({ itemName: event.target.value }) }}
				itemNameError={this.state.itemNameError}
				setItemNameError={(error) => { this.setState({ itemNameError: error }) }}
				//
				description={this.state.description}
				onDescriptionChange={(event) => { this.setState({ description: event.target.value }) }}
				descriptionError={this.state.descriptionError}
				setDescriptionError={(error) => { this.setState({ descriptionError: error }) }}
			/>
		)
	}

	onCancelCreate = () => {
		this.setState({
			submitted: false,
			errorList: null
		})
		this.props.onCancelCreate()
	}

	componentDidMount() {
		let context = this.props.context
		Modal.setAppElement('body')
	}

	onSubmit = () => {
		const { submitted } = this.state;
		if (submitted) return;

		this.setState({
			successMsg: null,
			errorList: [],
			submitted: true
		});

		RestApiUtils.post(this.props.context,
			`/api/su/accounts/${this.props.account.accountId}/productItems`,
			this.onSubmitCallback, {
			itemName: this.state.itemName,
			description: this.state.description,
			priceF: this.state.priceF,
			maker: this.state.maker,
		}
		);
	}

	onSubmitCallback = (response) => {
		let errorList = []
		response.errorList.forEach(error => {
			errorList.push(error.message)
		})

		this.setState({
			successMsg: response.success,
			errorList: errorList,
			submitted: false
		})

		if (response.errorList.length === 0) {
			setTimeout(() => {
				this.setState({
					successMsg: null
				})
				this.props.onCancelCreate()
				this.props.onRefreshClick()
			}, 1000)
		}
	}

	setErrorList = (errorList) => {
		this.setState({ errorList: errorList })
	}
}

export default ProductItemModalSF;